import makeStyles from '@mui/styles/makeStyles'

const drawerWidth = 240
export const FIXED_TITLE_LG_SCREEN_HEIGHT = 104
export const FIXED_TITLE_SM_SCREEN_HEIGHT = 80
export const FIXED_TITLE_WITH_ERROR_LG_SCREEN_HEIGHT = 180

export const useStyles = makeStyles(({ spacing, palette, typography, breakpoints }) => ({
  root: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center'
  },
  profileSectionDivider: {
    backgroundColor: palette.primary.main,
    height: '2px'
  },
  content: {
    flexGrow: 1,
    padding: spacing(3),
    [breakpoints.down('sm')]: {
      padding: spacing(0)
    },
    paddingTop: 0,
    height: '100%',
    overflow: 'auto',
    position: 'relative'
  },
  fixedTitle: {
    position: 'fixed',
    width: '100%',
    maxWidth: '944px',
    background: '#FFF',
    [breakpoints.down('sm')]: {
      padding: spacing(3, 0),
      paddingLeft: spacing(1)
    },
    marginLeft: spacing(-1),
    paddingLeft: spacing(1),
    zIndex: 2
  },
  seniorityLevelContainer: {
    padding: 12
  },
  innerContent: {
    marginTop: `${FIXED_TITLE_LG_SCREEN_HEIGHT}px`,
    [breakpoints.down('sm')]: {
      marginTop: `${FIXED_TITLE_SM_SCREEN_HEIGHT}px`
    }
  },
  innerContentWithError: {
    marginTop: `${FIXED_TITLE_WITH_ERROR_LG_SCREEN_HEIGHT}px`
  },
  profileSectionTitle: {
    ...typography.body.l,
    fontWeight: 500
  },
  accordion: {
    boxShadow: 'none',
    borderTop: '1px solid #DDDBE0'
  },
  accordionDetails: {
    overflowX: 'auto',
    whiteSpace: 'nowrap'
  },
  accordionPrimaryIcon: {
    backgroundColor: palette.primary.main,
    borderRadius: '50%',
    color: '#FFF'
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    position: 'relative',
    background: palette.primary.light,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: spacing(4),
    '& a': {
      color: palette.getContrastText(palette.primary.light)
    }
  },
  nav: {
    position: 'fixed',
    padding: 0
  },
  pageTitle: {
    padding: spacing(4, 0),
    fontWeight: typography.fontWeightBold,
    color: palette.grey.shade[100]
  },
  topicChip: {
    margin: spacing(0.5),
    borderRadius: spacing(1)
  },
  errorText: {
    color: 'red'
  },
  table: {
    display: 'block',
    overflowX: 'auto',
    whiteSpace: 'nowrap'
  }
}))
